import { jsx as i } from "react/jsx-runtime";
import { Skeleton as t } from "@mui/joy";
const e = ({ height: e2 = 350 }) => i("div", { style: { width: "100%", height: e2, padding: "60px", boxSizing: "border-box", display: "flex", alignItems: "flex-end", justifyContent: "space-around", gap: 5 }, children: [0.4, 0.7, 0.55, 0.85, 0.6, 0.75, 0.5, 0.9].map((e3, r) => i(t, { variant: "rectangular", width: 50, height: 300 * e3 + "px", sx: { borderRadius: "4px 4px 0 0" } }, r)) });
export {
  e as SkeletonBarChart
};
//# sourceMappingURL=SkeletonBarChart.js.map
